import React, {Component} from "react";
import Section from "./layouts/Section";
import {Link} from "react-router-dom";

class GameRepair extends Component {
    render() {
        return (
            <Section title={'Game Console Repair'}>
                <section className="section page-content">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="row">
                                    <div className="col-md-6">
                                        <img className="img-fluid shadow" style={{borderRadius: '10px'}} src={process.env.PUBLIC_URL + '/assets/images/consolebanner.jpg'} alt="" />
                                    </div>
                                    <div className="col-md-6 mt-4 mt-md-0">
                                        <h2 className="h1 text-dark mb-25">Need A Revive? We'll Get You Back In The Game.</h2>
                                        <p>Is your PlayStation, Xbox, or Nintendo console giving you trouble? Don't let hardware issues keep you out of the game. Our expert technicians specialize 
                                            in repairing all major gaming consoles. </p>
                                        <ul className="check-list mt-30">
                                            <li>Fast Turnaround Time</li>
                                            <li>Transparent Repair Process</li>
                                            <li>1 Year Warranty</li>
                                            <li>Satisfaction Guaranteed</li>
                                        </ul>
                                    </div>
                                </div>
                               
                            </div>
                            <div className="col-lg-4 mt-5 mt-lg-0">
                                <div className="widget widget-category">
                                    <div className="widget-heading">Category</div>
                                    <ul className="category-list list-unstyled p-4">
                                    <li><span className="fas fa-caret-right mr-2" /><Link to={'/pc-laptop-repair'} className="text-reset initiate-scripts">PC/Laptop Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/mobile-repair'} className="text-reset initiate-scripts">Mobile Device Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/game-repair'} className="text-reset initiate-scripts">Game Console Repair</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/monitoring'} className="text-reset initiate-scripts">Monitoring Solutions</Link></li>
                                        <li><span className="fas fa-caret-right mr-2 mt-3" /><Link to={'/consulting'} className="text-reset initiate-scripts">Consultations</Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Section>
        );
    }
}

export default GameRepair;